import React from "react";
import RefreshIndicator from "material-ui/RefreshIndicator";

export default class CustomRefreshIndicator extends React.PureComponent {
    render() {
        const {
            size = 40,
            left = 0,
            top = 0,
            status = "loading",
            loadingColor = "",
            style = {}
        } = this.props;
        return (
            <RefreshIndicator
                {...this.props}
                size={size}
                left={left}
                top={top}
                status={status}
                loadingColor={loadingColor}
                style={Object.assign({ position: "relative", margin: "0px auto" }, style)}
            />
        );
    }
}
